export const clickaway = {
  bind(el, { value }) {
    if (typeof value !== 'function') {
      return
    }

    document.addEventListener('click', e => el.contains(e.target) || value())
  }
}
